<template>
  <span
    class="one-click-cover"
    @click="click"
    :class="{hidden: !visible}"/>
</template>

<script>
    export default {
      name: 'OneClickCover',
      beforeCreate () {
        this.visible = true
      },
      data () {
        return {
          visible: this.visible
        }
      },
      methods: {
        click: function () {
          this.visible = false
          setTimeout(this.recover, 5000)
        },
        recover: function () {
          this.visible = true
        }
      }
    }
</script>
